import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const PredictionContext = createContext()

const today = new Date()
const currentYear = today.getFullYear()
const currentMonth = today.getMonth()
const startDate = new Date(currentYear, currentMonth, 1)

const STATUSES = {
  badpred: { name: 'Ruim Predição', type: 'bad', color: '#fd564e' },
  regularpred: { name: 'Regular Predição', type: 'regular', color: '#ffe000' },
  goodpred: { name: 'Bom Predição', type: 'good', color: '#62E751' },
}

export const PredictionProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingFilters, setLoadingFilters] = useState(true)
  const [dateRange, setDateRange] = useState([startDate, new Date()])
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [onShift, setOnShift] = useState('Sim')
  const [inputValue, setInputValue] = useState('')
  const [graphMessage, setGraphMessage] = useState(null)

  const renameStatusesNames = ({ data }) => {
    const renamed = data.map(output => {
      if (!STATUSES[output?.name]) return null

      return {
        ...output,
        name: STATUSES[output.name]?.name,
        type: STATUSES[output.name]?.type,
        color: STATUSES[output.name]?.color,
      }
    })

    return renamed.filter(data => data !== null)
  }

  const onSelectFilter = value => {
    setSelectedUser(null)
    setInputValue('')
    setSelectedFilterOptions(value)
  }

  const onSelectUser = value => {
    setSelectedUser(value)
    setInputValue(value.name)
    setSelectedFilterOptions([])
  }

  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const { data } = await RequestService.getShiftFatigue({
        date: dateRange,
        selectedFilterOptions,
        selectedUserId: selectedUser?.id,
        onShift,
      })

      const outputData = renameStatusesNames({ data: data.output })

      setData(outputData)
      setCategories(data.categories)
      setGraphMessage(data.graphMessage)
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  const getPossibleFilters = async () => {
    if (!loadingFilters) setLoadingFilters(true)

    try {
      const { data } = await RequestService.getShiftFatigueFilters()

      setFilterOptions(data)
    } catch (error) {
      console.error('Error on data fetch filters', error)
    }

    setLoadingFilters(false)
  }

  useEffect(() => {
    fetchData()
  }, [dateRange, selectedFilterOptions, selectedUser?.id, onShift])

  useEffect(() => {
    getPossibleFilters()
  }, [])

  return (
    <PredictionContext.Provider
      value={{
        data,
        loading,
        dateRange,
        onDateRangeChange: setDateRange,
        loadingFilters,
        filterOptions,
        onSelectFilter,
        selectedFilterOptions,
        selectedUser,
        onSelectUser,
        categories,
        onShift,
        onCheckOnShift: setOnShift,
        inputValue,
        onInputValueChange: setInputValue,
        graphMessage,
      }}
    >
      {children}
    </PredictionContext.Provider>
  )
}

export const usePrediction = () => {
  return useContext(PredictionContext)
}
